import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/update-sync")
export class AdminViewUpdateSyncBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.updateSync;
}